import { api } from "@/api/client";

export interface VendorRule {
  id: number;
  netsuite_vendor_id: number | null;
  name: string;
  active: boolean;
  default: boolean;
  aliases: string[];
  ocr_hints: Record<string, unknown>;
  ai_instructions: string | null;
  field_mappings: Record<string, unknown>;
  defaults: Record<string, unknown>;
  prompt_version: string | null;
  updated_by?: { id: number; email: string } | null;
  updated_at: string;
  bill_count: number;
}

export interface VendorRuleUpdate {
  name?: string;
  active?: boolean;
  aliases?: string[];
  ai_instructions?: string;
  defaults?: Record<string, unknown>;
  ocr_hints?: Record<string, unknown>;
  field_mappings?: Record<string, unknown>;
}

export async function fetchVendorRules(): Promise<VendorRule[]> {
  const { data } = await api.get<{ items: VendorRule[] }>("/vendor_rules");
  return data.items;
}

export async function updateVendorRule(id: number, update: VendorRuleUpdate): Promise<VendorRule> {
  const { data } = await api.patch<VendorRule>(`/vendor_rules/${id}`, { vendor_rule: update });
  return data;
}
